import { render, staticRenderFns } from "./TableAssessmentsContainer.vue?vue&type=template&id=68323368&"
import script from "./TableAssessmentsContainer.vue?vue&type=script&lang=ts&"
export * from "./TableAssessmentsContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports